import {ChangeDetectorRef, Component, OnInit, OnDestroy, AfterViewInit, ViewChild, TemplateRef} from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject, Subscription } from "rxjs";
import { debounceTime, throttleTime } from "rxjs/operators";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Usuario } from "src/app/models/Usuario/Usuario";
import { AuthService } from "src/app/modules/auth";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { WebpayPaymentService } from "src/app/services/webpay-payment.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import Swal from "sweetalert2";
import { UtilitiesService } from "src/app/services/utilities.service";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { PlanFacturacion } from "src/app/models/PlanesUsuario/PlanFacturacion";
import { HistorialItem } from "src/app/models/PlanesUsuario/HistorialItem";
import { ConsumoDetalleMensualItem } from "src/app/models/PlanesUsuario/ConsumoDetalleMensualItem";
import * as moment from "moment";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { Adicional } from "src/app/models/Emisor/Adicional";
import { AdicionalType } from "src/app/shared/models/AdicionalType.enum";
import { CypressService } from "src/app/services/cypress.service";
import { ChartOptions } from "src/app/models/ChartOptions";
import { ResumenBloqueComponent } from "src/app/components/pago/resumen-bloque/resumen-bloque.component";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { SortType } from "@swimlane/ngx-datatable";
import { CertificacionCliente } from "src/app/models/PlanesUsuario/CertificacionCliente";
import { CertificacionInstructivo } from "src/app/models/PlanesUsuario/CertificacionInstructivo";
import { DeudaAdicionalPendiente } from "src/app/models/PlanesUsuario/DeudaAdicionalPendiente";
import { DeudaGraciaPendiente } from "src/app/models/PlanesUsuario/DeudaGraciaPendiente";
import { PlanPaymentState } from "src/app/models/PlanesUsuario/PlanPaymentState";
import { SaldoSeleccion } from "src/app/models/Saldo/SaldoSeleccion";
import { SaldoFavorCalculo } from "src/app/components/pago/saldo-favor-bloque/saldo-favor-calculo";
import { SaldoPagoUi } from "src/app/components/pago/saldo-favor-bloque/saldo-pago-ui";
import { solicitarRefrescoSaldo } from "src/app/services/saldo.service";
@Component({
	selector: "app-plan-facturacion",
	templateUrl: "./plan-facturacion.component.html",
	styleUrls: ["./plan-facturacion.component.scss"],
})
export class PlanFacturacionComponent implements OnInit, OnDestroy, AfterViewInit {
	SortType = SortType;
	public loading = false;
	public isCertModalOpen = false;
	public user: SessionUser;
	public currentUser: Usuario = new Usuario();
	public currentEmisorObject: Emisor;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public emisores: Emisor[] = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
	public usuarioId: string;
	public emisorId: string;
	private paymentPlanModal: NgbModalRef;
	public facturasPlan: PlanFacturacion[] = [];
	public adicionales: Adicional[] = [];
	public rowsPlanes: PlanUsuario[] = [];
	public planActual: PlanUsuario;
	public planSeleccionado: Plan;
	public rowsDatosFacturacion: EmpresaFacturacion[] = [];
	public datosFacturacion: EmpresaFacturacion;
	public chartOptions: Partial<ChartOptions>;
	public resumenCuenta: Resumen;
	public saldoAdicionales: SaldoSeleccion = { usarSaldoFavor: false, saldoAplicadoEsperado: 0 };
	public certificaciones: CertificacionPrecio[] = [];
	public certificacionesTab: CertificacionCliente[] = [];
	public isCalculatingCerts = false;
	public certModalLoading = false;
	private lastCertChangeTime = 0;
	private certsChange$ = new Subject<void>();
	private certsChangeSub: Subscription;
	@ViewChild(ResumenBloqueComponent) resumenBloque: ResumenBloqueComponent;
	@ViewChild("certificacionFechaForm") certificacionFechaForm: TemplateRef<any>;
	public planes: Plan[];
	public nuevaFechaCaducidad: moment.Moment;
	public hasAdicionales = false;
	public fechaActual = moment().startOf("day");
	public planActualNuevo: Plan;
	public planesNoSeleccionablesIds: string[] = [];
	public fechaCertificacion: string;
	private paymentType: string;
	public downgradeRestringido: boolean = false;
	public fechaHabilitacionDowngrade: string = '';
	private certificacionFechaModal: NgbModalRef;
	public activeTab = "resumen";
	public accesoPanelEvaluado = false;
	public usuarioBaseEvaluado = false;
	public usuarioBasePuedeAdministrarPlan = false;
	public facturasLoaded = false;
	public adicionalesLoaded = false;
	public deudaAdicionalLoaded = false;
	public certificacionesTabLoaded = false;
	public consumoDetalleMensual: ConsumoDetalleMensualItem[] = [];
	private readonly certificacionEstadoDesactivadaId = 6;
	public filtroFolio = "";
	public filtroEstado = "";
	public paginaFacturas = 0;
	public readonly tamanioPaginaFacturas = 10;
	public adicionalesDisponibles: Adicional[] = [];
	public isAdicionalesModalOpen = false;
	public cotizacionAdicionales: any = null;
	public deudaAdicionalPendiente: DeudaAdicionalPendiente = new DeudaAdicionalPendiente();
	public pagandoDeudaAdicional = false;
	public deudaGraciaPendiente: DeudaGraciaPendiente = new DeudaGraciaPendiente();
	public paymentState: PlanPaymentState | null = null;

	get ultimoResultadoPagoTexto(): string {
		const labels = {
			Pending: "Pendiente",
			Approved: "Aprobado",
			Rejected: "Rechazado",
			Cancelled: "Cancelado",
			Abandoned: "Abandonado",
			Expired: "Expirado",
		};
		return this.paymentState?.lastPaymentResult ? labels[this.paymentState.lastPaymentResult] : "Sin intentos";
	}

	get hayCertificacionesSeleccionadas(): boolean {
		return this.certificaciones?.some((c) => c.solicitada && !c.disabled) ?? false;
	}

	get hasReseller(): boolean {
		return this.tokenService.userHasReseller();
	}

	get canAccessPlanFacturacionPanel(): boolean {
		const permiso = this.permissions?.getPermission?.("82");
		return !!this.planActual && !!permiso?.asignado && !this.hasReseller && this.usuarioBasePuedeAdministrarPlan;
	}

	get esPlanDemo(): boolean {
		if (!this.planActual) return false;
		return Boolean(this.planActual.isDemo) || (this.diasRestantes > 0 && !this.planActual.pagado);
	}

	get infoEstadoServicio() {
		if (!this.planActual) {
			return { estado: "", glosa: "", colorClass: "secondary", canRegularizar: false };
		}
		const diasDiferencia = this.getDiasDiferenciaSoloFecha(this.planActual.fechaCaducidad);
		if (!this.planActual.activo || diasDiferencia < -15) {
			return {
				estado: "Plan sin vigencia",
				glosa: "Renueva para comenzar una nueva vigencia desde el pago",
				colorClass: "danger",
				canRegularizar: true,
			};
		}

		if (diasDiferencia < 0) {
			return {
				estado: "En mora",
				glosa: "En mora (dentro de los 15 días de gracia)",
				colorClass: "warning",
				canRegularizar: true,
			};
		}

		if (diasDiferencia <= 30) {
			return {
				estado: "Sin deuda",
				glosa: `Sin mora, corte en ${diasDiferencia} días`,
				colorClass: "primary",
				canRegularizar: false,
			};
		}

		return {
			estado: "Sin deuda",
			glosa: "Sin deuda pendiente",
			colorClass: "success",
			canRegularizar: false,
		};
	}

	get diasRestantes(): number {
		if (!this.planActual) return 0;
		return Math.max(0, this.getDiasDiferenciaSoloFecha(this.planActual.fechaCaducidad));
	}

	get puedeExtenderPlan(): boolean {
		if (!this.planActual) return false;
		return !this.infoEstadoServicio.canRegularizar && !this.tieneDeudaAdicionalPendiente && !this.tieneDeudaGraciaPendiente;
	}

	get puedeHacerDowngrade(): boolean {
		if (!this.planActual) return false;
		const fechaInicioVentanaDowngrade = this.fechaInicioVentanaDowngrade;
		if (!fechaInicioVentanaDowngrade) return false;
		const hoy = this.todayDayMoment();
		return !this.tieneDeudaAdicionalPendiente
			&& !this.tieneDeudaGraciaPendiente
			&& hoy.isSameOrAfter(fechaInicioVentanaDowngrade, "day");
	}

	get puedeCambiarPlan(): boolean {
		if (!this.planActual) return false;
		return !this.tieneDeudaAdicionalPendiente && !this.tieneDeudaGraciaPendiente;
	}

	get puedeRegularizarPlan(): boolean {
		if (!this.planActual) return false;
		return this.infoEstadoServicio.canRegularizar
			&& !this.tieneDeudaAdicionalPendiente
			&& !this.tieneDeudaGraciaPendiente;
	}

	get mostrarGlosaNuevaVigenciaCambio(): boolean {
		if (!this.planActual || !this.planSeleccionado || !this.resumenCuenta || !this.nuevaFechaCaducidad) return false;

		return (
			this.planSeleccionado.id !== this.planActual.idPlanSf &&
			this.resumenCuenta.idPlanSf === this.planSeleccionado.id &&
			this.resumenCuenta.permitido !== false &&
			this.nuevaFechaCaducidad.isValid() &&
			this.nuevaFechaCaducidad.isAfter(this.fechaActual, "day")
		);
	}

	get tooltipRegularizarPlan(): string {
		if (this.tieneDeudaGraciaPendiente) {
			return "Primero debes pagar el uso del periodo de gracia.";
		}
		if (this.tieneDeudaAdicionalPendiente) {
			return "No puedes regularizar porque tu plan tiene deuda. Paga la deuda primero.";
		}
		return this.infoEstadoServicio.canRegularizar
			? "Realiza el pago para regularizar tu plan"
			: "Tu plan está al día no necesita regularización";
	}

	get fechaHabilitacionDowngradeCalc(): string {
		const fechaInicioVentanaDowngrade = this.fechaInicioVentanaDowngrade;
		return fechaInicioVentanaDowngrade ? fechaInicioVentanaDowngrade.format("DD/MM/YYYY") : "";
	}

	isDowngrade(plan: Plan): boolean {
		if (!plan || !this.planActual) return false;
		return plan.precio < this.planActual.pagoMensual;
	}

	private getDiasDiferenciaSoloFecha(fechaCaducidad: Date | string): number {
		if (!fechaCaducidad) return 0;
		const fechaFin = this.toDayMoment(fechaCaducidad);
		const hoy = this.todayDayMoment();
		if (!fechaFin.isValid()) return 0;
		return fechaFin.diff(hoy, "days");
	}

	private toDayMoment(fecha: Date | string | moment.Moment): moment.Moment {
		return moment(fecha).startOf("day");
	}

	private toDateTimeMoment(fecha: Date | string | moment.Moment): moment.Moment {
		return moment(fecha);
	}

	private todayDayMoment(): moment.Moment {
		return moment().startOf("day");
	}

	private get fechaInicioVentanaDowngrade(): moment.Moment | null {
		if (!this.planActual?.fechaCaducidad) return null;
		const fechaCaducidad = this.toDayMoment(this.planActual.fechaCaducidad);
		return fechaCaducidad.isValid() ? fechaCaducidad.clone().subtract(1, "month") : null;
	}

	private isDateOnOrAfterToday(fecha: Date | string): boolean {
		if (!fecha) return false;
		return this.toDayMoment(fecha).isSameOrAfter(this.todayDayMoment(), "day");
	}

	get usoDtePorcentaje(): number {
		if (!this.planActual || this.planActual.maxDte === -1) return 0;
		return Math.min(100, Math.round((this.planActual.currentDte / this.planActual.maxDte) * 100));
	}

	get usoBhePorcentaje(): number {
		if (!this.planActual || this.planActual.maxBhe === -1) return 0;
		return Math.min(100, Math.round((this.planActual.currentBhe / this.planActual.maxBhe) * 100));
	}

	get usoEnRango(): boolean {
		return this.usoDtePorcentaje < 80 && this.usoBhePorcentaje < 80;
	}

	get facturasFiltradas(): PlanFacturacion[] {
		return (this.facturasPlan ?? []).filter((f) => {
			const folioOk = !this.filtroFolio || String(f.folio).includes(this.filtroFolio);
			const estadoOk =
				!this.filtroEstado ||
				(this.filtroEstado === "pagada" && f.pagada) ||
				(this.filtroEstado === "pendiente" && !f.pagada);
			return folioOk && estadoOk;
		});
	}

	get facturasPaginadas(): PlanFacturacion[] {
		const start = this.paginaFacturas * this.tamanioPaginaFacturas;
		return this.facturasFiltradas.slice(start, start + this.tamanioPaginaFacturas);
	}

	get totalPaginasFacturas(): number {
		return Math.ceil(this.facturasFiltradas.length / this.tamanioPaginaFacturas);
	}

	get adicionalesVigentes(): Adicional[] {
		return (this.adicionales ?? []).filter((a) => this.isAdicionalVigente(a));
	}

	get ultimasFacturas(): PlanFacturacion[] {
		return [...(this.facturasPlan ?? [])]
			.sort((a, b) => new Date(b.fechaEmision).getTime() - new Date(a.fechaEmision).getTime())
			.slice(0, 5);
	}

	get tieneDeudaAdicionalPendiente(): boolean {
		const emisorActualId = this.planActual?.emisorId ?? this.emisorId;
		const emisorConDeudaId = this.deudaAdicionalPendiente?.emisorId;

		if (!this.usuarioBasePuedeAdministrarPlan || !this.deudaAdicionalPendiente?.tieneDeuda || !emisorActualId) {
			return false;
		}

		return !emisorConDeudaId || emisorConDeudaId === emisorActualId;
	}

	get tieneDeudaGraciaPendiente(): boolean {
		const emisorActualId = this.planActual?.emisorId ?? this.emisorId;
		const emisorConDeudaId = this.deudaGraciaPendiente?.emisorId;

		if (!this.usuarioBasePuedeAdministrarPlan || !this.deudaGraciaPendiente?.tieneDeuda
			|| this.deudaGraciaPendiente?.ventanaEnCurso || !emisorActualId) {
			return false;
		}

		return !emisorConDeudaId || emisorConDeudaId === emisorActualId;
	}

	get paginasArray(): number[] {
		return Array.from({ length: this.totalPaginasFacturas }, (_, i) => i);
	}

	isAdicionalVigente(adicional: Adicional): boolean {
		if (this.isAdicionalPendiente(adicional)) {
			return false;
		}
		return this.isAdicionalSinVencimiento(adicional) || this.isDateOnOrAfterToday(adicional.fechaTermino);
	}

	isAdicionalSinVencimiento(adicional: Adicional): boolean {
		return !this.tieneFechaTermino(adicional);
	}

	isAdicionalPendiente(adicional: Adicional): boolean {
		if (!adicional?.fechaInicio) return false;
		const fechaInicio = this.toDayMoment(adicional.fechaInicio);
		return fechaInicio.isValid() && fechaInicio.isAfter(this.todayDayMoment(), "day");
	}

	getAdicionalEstadoTexto(adicional: Adicional): string {
		if (this.isAdicionalPendiente(adicional)) return "Pendiente";
		return this.isAdicionalVigente(adicional) ? "Vigente" : "Vencido";
	}

	getAdicionalFechaTerminoTexto(adicional: Adicional): string {
		if (this.isAdicionalSinVencimiento(adicional)) return "Sin fecha de termino";
		return this.toDayMoment(adicional.fechaTermino).format("DD/MM/YYYY");
	}

	private isPaykuAdicional(adicional: Adicional): boolean {
		return Number(adicional?.idAdicional) === AdicionalType.Payku;
	}

	getAdicionalEstadoClass(adicional: Adicional): string {
		if (this.isAdicionalPendiente(adicional)) {
			return "pf-status-badge pf-status-badge--warning";
		}
		return this.isAdicionalVigente(adicional)
			? "pf-status-badge pf-status-badge--success"
			: "pf-status-badge pf-status-badge--danger";
	}

	private tieneFechaTermino(adicional: Adicional): boolean {
		if (!adicional?.fechaTermino) return false;
		const fechaTermino = this.toDayMoment(adicional.fechaTermino);
		return fechaTermino.isValid() && fechaTermino.year() > 1;
	}

	get adicionalesChecked(): Adicional[] {
		return this.adicionalesDisponibles.filter((a) => a.checked && !a.readOnly);
	}

	get totalAdicionalesCalc(): { neto: number; iva: number; total: number } {
		if (this.cotizacionAdicionales) {
			return { neto: this.cotizacionAdicionales.neto, iva: this.cotizacionAdicionales.iva, total: this.cotizacionAdicionales.total };
		}
		return { neto: 0, iva: 0, total: 0 };
	}

	get totalesAdicionalesConSaldo(): { neto: number; iva: number; total: number } {
		return SaldoFavorCalculo.totalesConDescuentoNeto(
			this.totalAdicionalesCalc.neto,
			this.saldoAdicionales.usarSaldoFavor ? this.saldoAdicionales.saldoAplicadoEsperado : 0
		);
	}

	get diferenciaPagoAdicionales(): number {
		return this.totalesAdicionalesConSaldo.total;
	}

	actualizarSaldoAdicionales(seleccion: SaldoSeleccion): void {
		this.saldoAdicionales = { ...seleccion };
	}

	get hayAdicionalesSeleccionados(): boolean {
		return this.adicionalesChecked.length > 0;
	}

	get esSoloPaykuSeleccionado(): boolean {
		return this.adicionalesChecked.length === 1 && this.adicionalesChecked.every((a) => this.isPaykuAdicional(a));
	}

	get historialColumnas(): { izq: HistorialItem[]; der: HistorialItem[] } {
		const items = this.historialItems;
		const mitad = Math.ceil(items.length / 2);
		return { izq: items.slice(0, mitad), der: items.slice(mitad) };
	}

	get historialItems(): HistorialItem[] {
		const items: HistorialItem[] = [];

		if (this.planActual?.fechaContratacion) {
			const fechaPlan = this.toDateTimeMoment(this.planActual.fechaContratacion);
			if (fechaPlan.isValid()) {
			items.push({
				tipo: "plan_activado",
				fecha: fechaPlan.toDate(),
				titulo: "Plan activado",
				descripcion: `Plan ${this.planActual.nombrePlan} — contratación inicial`,
				icono: "fa-regular fa-circle-check",
				colorClass: "success",
			});
			}
		}

		(this.facturasPlan ?? []).forEach((f) => {
			const fechaFactura = this.toDateTimeMoment(f.fechaEmision);
			if (!fechaFactura.isValid()) return;
			items.push({
				tipo: "factura_emitida",
				fecha: fechaFactura.toDate(),
				titulo: "Factura emitida",
				descripcion: `Folio ${f.folio} — $ ${f.total.toLocaleString("es-CL", { maximumFractionDigits: 0 })}`,
				icono: "fa-regular fa-file-invoice-dollar",
				colorClass: "primary",
				extra: f.pagada ? "Pagada" : "Pendiente de pago",
				extraClass: f.pagada ? "success" : "warning",
			});
		});

		(this.adicionales ?? []).filter((a) => a.fechaInicio).forEach((a) => {
			const fechaAdicional = this.toDateTimeMoment(a.fechaInicio);
			if (!fechaAdicional.isValid()) return;
			items.push({
				tipo: "adicional_contratado",
				fecha: fechaAdicional.toDate(),
				titulo: "Adicional contratado",
				descripcion: a.nombre + (a.descripcion ? ` — ${a.descripcion}` : ""),
				icono: "fa-regular fa-circle-plus",
				colorClass: "info",
			});
		});

		const certificacionesPorFecha = new Map<string, { fecha: Date; nombres: Set<string> }>();
		(this.certificacionesTab ?? [])
			.filter((c) => c?.fechaSolicitud)
			.forEach((c) => {
				const fechaSolicitud = this.toDateTimeMoment(c.fechaSolicitud!);
				if (!fechaSolicitud.isValid()) return;

				const key = fechaSolicitud.format("YYYY-MM-DD HH:mm:ss.SSS");
				if (!certificacionesPorFecha.has(key)) {
					certificacionesPorFecha.set(key, {
						fecha: fechaSolicitud.toDate(),
						nombres: new Set<string>(),
					});
				}
				const grupo = certificacionesPorFecha.get(key);
				if (!grupo) return;

				const nombre = (c.nombreCertificacion ?? "").trim();
				if (nombre) {
					grupo.nombres.add(nombre);
				}
			});

		certificacionesPorFecha.forEach((entry) => {
			const nombres = Array.from(entry.nombres);
			items.push({
				tipo: "certificaciones_solicitadas",
				fecha: entry.fecha,
				titulo: "Certificaciones solicitadas",
				descripcion: nombres.length ? nombres.join(", ") : "Sin detalle de certificaciones",
				icono: "fa-regular fa-certificate",
				colorClass: "warning",
			});
		});

		return items.sort((a, b) => a.fecha.getTime() - b.fecha.getTime());
	}

	constructor(
		public utilities: UtilitiesService,
		private pagoService: PagoUsuarioService,
		private tokenService: TokenStorageService,
		private userService: UsuarioService,
		public modalService: NgbModal,
		public permissions: PermissionService,
		public emisorService: EmisorService,
		public planService: PlanUsuarioService,
		private router: Router,
		public authService: AuthService,
		public datosFacturacionServicce: DatosFacturacionService,
		private localStorage: LocalStorageService,
		private cypressService: CypressService,
		private webpayService: WebpayPaymentService,
		private ref: ChangeDetectorRef
	) {
		this.usuarioId = tokenService.getUser().id;
		this.user = tokenService.getUser() as SessionUser;
		this.emisorId = this.tokenService.getCompany();
		const emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.currentEmisorObject = emisoresSource.find((x) => x.emisorId == this.tokenService.getCompany());
	}

	ngOnInit(): void {
		this.certsChangeSub = this.certsChange$
			.pipe(
				throttleTime(1000, undefined, { leading: true, trailing: true }),
				debounceTime(1000)
			)
			.subscribe(() => {
				if (this.isCertModalOpen && !this.isCalculatingCerts) {
					this.recalcularResumenCertificaciones();
				}
			});
	}

	ngOnDestroy(): void {
		if (this.certsChangeSub) this.certsChangeSub.unsubscribe();
	}

	ngAfterViewInit() {
		this.loadData();
	}

	loadData() {
		this.accesoPanelEvaluado = false;
		this.usuarioBaseEvaluado = false;
		this.usuarioBasePuedeAdministrarPlan = false;
		this.loading = true;
		this.deudaAdicionalLoaded = false;
		this.paymentState = null;
		this.planService.getPaymentStateByCompany(this.emisorId).subscribe({
			next: (state) => { this.paymentState = state; this.ref.detectChanges(); },
			error: () => { this.paymentState = null; },
		});
		this.planService.getContratacionDataByCompany(this.emisorId).subscribe(
			(elements: PlanUsuario[]) => {
				this.rowsPlanes = [...elements];
				this.planActual = this.rowsPlanes.find((x) => x.emisorId == this.emisorId);

				if (this.planActual) {
					this.userService.getUser(this.user.id, this.emisorId).subscribe(
						(response) => {
							this.usuarioBasePuedeAdministrarPlan = this.hasPlanesUsuario(response);
							this.usuarioBaseEvaluado = true;
							this.accesoPanelEvaluado = true;

							if (!this.canAccessPlanFacturacionPanel) {
								this.loading = false;
								this.ref.detectChanges();
								return;
							}

							this.loadPlanFacturacionData();
						},
						() => {
							this.usuarioBaseEvaluado = true;
							this.usuarioBasePuedeAdministrarPlan = false;
							this.loading = false;
							this.accesoPanelEvaluado = true;
							this.ref.detectChanges();
						}
					);
				} else {
					this.loading = false;
					this.usuarioBaseEvaluado = true;
					this.accesoPanelEvaluado = true;
					this.ref.detectChanges();
				}
			},
			() => {
				this.loading = false;
				this.usuarioBaseEvaluado = true;
				this.accesoPanelEvaluado = true;
				this.ref.detectChanges();
			}
		);
	}

	private hasPlanesUsuario(response: any): boolean {
		return Array.isArray(response?.data?.planesUsuario) && response.data.planesUsuario.length > 0;
	}

	private loadPlanFacturacionData(): void {
		this.planService.getDteChartData(this.emisorId).subscribe(
			(response) => {
				this.setupChart(response.data);
				this.loading = false;
				this.ref.detectChanges();
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);

		this.planService.getInitialData().subscribe((data) => {
			this.planes = data.planes;
			this.planActualNuevo = this.planes.find(
				(x) => x.nombre === this.planActual.nombrePlan && x.antiguedad === "Nuevo"
			);
			this.ref.detectChanges();
		});

		this.planService.getFacturasByPlan(this.planActual.idPlanUsuario).subscribe((data) => {
			this.facturasPlan = data ?? [];
			this.facturasLoaded = true;
			this.ref.detectChanges();
		});

		this.emisorService.getAdicionales(this.planActual.emisorId).subscribe((data) => {
			this.adicionales = data ?? [];
			this.adicionalesLoaded = true;
			this.ref.detectChanges();
		});

		this.loadPendingAdditionalDebt(this.planActual?.emisorId ?? this.emisorId);
	}

	actualizarPanel() {
		if (this.loading) return;
		this.paginaFacturas = 0;
		this.loadData();
		if ((this.activeTab === "certificaciones" || this.activeTab === "historial") && this.planActual?.idPlanUsuario) {
			this.certificacionesTabLoaded = false;
			this.loadCertificacionesTab();
		}
	}

	private setupChart(monthData: any[]) {
		if (!monthData?.length) {
			this.consumoDetalleMensual = [];
			return;
		}
		const categories = monthData.map((m) => m.monthYear ?? m.MonthYear);
		const dteData = monthData.map((m) => Number(m.count ?? m.Count ?? 0));
		const bheData = monthData.map((m) => Number(m.bheCount ?? m.BheCount ?? 0));

		this.chartOptions = {
			series: [
				{ name: "DTEs emitidos", data: dteData },
				{ name: "BHE emitidas", data: bheData },
			],
			chart: { height: 250, width: "100%", type: "line", toolbar: { show: false } },
			dataLabels: { enabled: false },
			stroke: { curve: "smooth", width: [3, 3] },
			markers: { size: [3, 4] },
			colors: ["#1f6feb", "#14b8a6"],
			title: { text: "Evolución de emisiones (últimos 6 meses)", align: "center" },
			xaxis: { type: "category", categories },
			yaxis: [
				{ title: { text: "DTE" }, min: 0, forceNiceScale: true },
				{ opposite: true, title: { text: "BHE" }, min: 0, forceNiceScale: true },
			],
			legend: { show: true, position: "bottom" },
		};

		const limiteDte = this.planActual?.maxDte > 0 ? this.planActual.maxDte : null;
		const limiteBhe = this.planActual?.maxBhe > 0 ? this.planActual.maxBhe : null;
		this.consumoDetalleMensual = monthData.map((m) => {
			const dteEmitidos = Number(m.count ?? m.Count ?? 0);
			const bheEmitidos = Number(m.bheCount ?? m.BheCount ?? 0);
			return {
				mes: this.formatMonthLabel(m.monthYear ?? m.MonthYear),
				dteEmitidos,
				limiteDte,
				porcentajeDte: this.calcularPorcentajeUso(dteEmitidos, limiteDte),
				bheEmitidos,
				limiteBhe,
				porcentajeBhe: this.calcularPorcentajeUso(bheEmitidos, limiteBhe),
			};
		});
	}

	private calcularPorcentajeUso(emitidos: number, limite: number | null): number | null {
		if (!limite || limite <= 0) return null;
		return Math.round((emitidos / limite) * 100);
	}

	private formatMonthLabel(rawLabel: string): string {
		if (!rawLabel) return "";
		const clean = String(rawLabel).trim().replace(".", "").toUpperCase();
		const [mesRaw, anioRaw] = clean.split("-");
		if (!mesRaw || !anioRaw) return rawLabel;

		const meses: Record<string, string> = {
			ENE: "Ene",
			FEB: "Feb",
			MAR: "Mar",
			ABR: "Abr",
			MAY: "May",
			JUN: "Jun",
			JUL: "Jul",
			AGO: "Ago",
			SEP: "Sep",
			OCT: "Oct",
			NOV: "Nov",
			DIC: "Dic",
		};

		const mes = meses[mesRaw] ?? mesRaw.charAt(0) + mesRaw.slice(1).toLowerCase();
		const anioCorto = anioRaw.length >= 2 ? anioRaw.slice(-2) : anioRaw;
		return `${mes} ${anioCorto}`;
	}

	onTabChange(tabId: string) {
		if (tabId === "certificaciones" && !this.certificacionesTabLoaded) {
			this.loadCertificacionesTab();
		}
		if (tabId === "historial" && !this.certificacionesTabLoaded) {
			this.loadCertificacionesTab();
		}
	}

	private loadCertificacionesTab() {
		if (!this.planActual?.idPlanUsuario) {
			this.certificacionesTab = [];
			this.certificacionesTabLoaded = true;
			this.ref.detectChanges();
			return;
		}
		this.planService.getCertificacionesCliente(this.planActual.idPlanUsuario).subscribe({
			next: (resp) => {
				const certsNormalizadas = ((resp ?? []) as any[]).map((c) => ({
					certificacionId: c?.certificacionId ?? c?.CertificacionId ?? "",
					codigoSii: Number(c?.codigoSii ?? c?.CodigoSii ?? 0),
					nombreCertificacion: c?.nombreCertificacion ?? c?.NombreCertificacion ?? "",
					estadoId: Number(c?.estadoId ?? c?.EstadoId ?? 0),
					estadoNombre: c?.estadoNombre ?? c?.EstadoNombre ?? "",
					fechaSolicitud: c?.fechaSolicitud ?? c?.FechaSolicitud ?? null,
					fechaFinalizacion: c?.fechaFinalizacion ?? c?.FechaFinalizacion ?? null,
					fechaConfirmada: c?.fechaConfirmada ?? c?.FechaConfirmada ?? null,
					pagado: Boolean(c?.pagado ?? c?.Pagado),
				})) as CertificacionCliente[];

				this.certificacionesTab = certsNormalizadas.filter((c) => {
					const estadoNombre = (c.estadoNombre ?? "").trim().toLowerCase();
					return Number(c.estadoId) !== this.certificacionEstadoDesactivadaId && estadoNombre !== "desactivada";
				});
				this.certificacionesTabLoaded = true;
				this.ref.detectChanges();
			},
			error: () => {
				this.certificacionesTab = [];
				this.certificacionesTabLoaded = true;
				this.ref.detectChanges();
			},
		});
	}

	getCertEstadoClass(estadoId: number): string {
		switch (Number(estadoId)) {
			case 1:
			case 4:
				return "badge-light-success";
			case 2:
				return "badge-light-primary";
			case 3:
				return "badge-light-danger";
			case 5:
				return "badge-light-info";
			case 6:
				return "badge-light-secondary";
			default:
				return "badge-light-warning";
		}
	}

	puedeGestionarInstructivo(cert: CertificacionCliente): boolean {
		const estado = Number(cert?.estadoId ?? 0);
		return estado === 4 || estado === 5;
	}

	descargarInstructivo(cert: CertificacionCliente): void {
		if (!this.planActual?.idPlanUsuario || !cert?.certificacionId) return;

		this.planService.getInstructivoCertificacion(this.planActual.idPlanUsuario, cert.certificacionId).subscribe({
			next: (resp) => {
				const data = resp?.data as CertificacionInstructivo;
				if (!data?.instructivoUrl) {
					Swal.fire("No disponible", "No fue posible resolver el instructivo para esta certificación.", "warning");
					return;
				}

				window.open(data.instructivoUrl, "_blank", "noopener,noreferrer");
			},
			error: (error) => {
				Swal.fire("Error", "No fue posible abrir el instructivo." + this.utilities.setErrorMessageFromArray(error?.error), "error");
			},
		});
	}

	reenviarInstructivo(cert: CertificacionCliente): void {
		if (!this.planActual?.idPlanUsuario || !cert?.certificacionId) return;

		Swal.fire({
			title: "Reenviar instructivo",
			text: "Ingresa el correo de destino. Si lo dejas vacío, se usará el correo asociado al proceso.",
			input: "email",
			inputValue: this.user?.email ?? "",
			showCancelButton: true,
			confirmButtonText: "Reenviar",
			cancelButtonText: "Cancelar",
			inputValidator: (value) => {
				if (!value) return null;
				const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
				return ok ? null : "Debes ingresar un correo válido.";
			},
		}).then((result) => {
			if (!result.isConfirmed) return;

			this.planService.reenviarInstructivoCertificacion({
				idPlanUsuario: this.planActual.idPlanUsuario,
				certificacionId: cert.certificacionId,
				correoDestino: result.value || undefined,
			}).subscribe({
				next: () => {
					Swal.fire("Listo", "El instructivo fue reenviado correctamente.", "success");
				},
				error: (error) => {
					Swal.fire("Error", "No fue posible reenviar el instructivo." + this.utilities.setErrorMessageFromArray(error?.error), "error");
				},
			});
		});
	}

	onFiltrarFacturas() {
		this.paginaFacturas = 0;
	}
	irPagina(p: number) {
		this.paginaFacturas = p;
	}

	filtro(event) {}

	private loadPendingAdditionalDebt(emisorId: string): void {
		this.planService.getDeudaGracia(emisorId, this.planActual?.idPlanUsuario).subscribe({
			next: (deuda) => {
				this.deudaGraciaPendiente = deuda?.emisorId && deuda.emisorId !== emisorId
					? new DeudaGraciaPendiente()
					: (deuda ?? new DeudaGraciaPendiente());
				this.ref.detectChanges();
			},
			error: () => {
				this.deudaGraciaPendiente = new DeudaGraciaPendiente();
				this.ref.detectChanges();
			},
		});
		this.planService.getPendingAdditionalDebt(emisorId).subscribe({
			next: (deuda) => {
				this.deudaAdicionalPendiente = deuda?.emisorId && deuda.emisorId !== emisorId
					? new DeudaAdicionalPendiente()
					: (deuda ?? new DeudaAdicionalPendiente());
				this.deudaAdicionalLoaded = true;
				this.ref.detectChanges();
			},
			error: () => {
				this.deudaAdicionalPendiente = new DeudaAdicionalPendiente();
				this.deudaAdicionalLoaded = true;
				this.ref.detectChanges();
			},
		});
	}

	pagarDeudaAdicional(): void {
		if (!this.tieneDeudaAdicionalPendiente || this.pagandoDeudaAdicional) return;

		this.pagandoDeudaAdicional = true;
		this.ref.detectChanges();

		if (this.datosFacturacion?.emisorDatosId) {
			this.iniciarPagoDeudaAdicional();
			return;
		}

		const emisorId = this.planActual?.emisorId ?? this.emisorId;
		this.datosFacturacionServicce.getData(this.usuarioId, emisorId).subscribe({
			next: (data) => {
				this.datosFacturacion = data.find((x) => x.emisorId === emisorId) ?? data[0];
				if (!this.datosFacturacion?.emisorDatosId) {
					this.finalizarPagoDeudaConError("No encontramos los datos de facturación de la empresa. Contacta a soporte para regularizar tu deuda.");
					return;
				}
				this.iniciarPagoDeudaAdicional();
			},
			error: () => this.finalizarPagoDeudaConError("No fue posible obtener los datos de facturación. Intenta nuevamente."),
		});
	}

	private iniciarPagoDeudaAdicional(): void {
		this.planService
			.payPendingAdditionalDebt({
				idUsuario: this.usuarioId,
				idEmisor: this.planActual?.emisorId ?? this.emisorId,
				idDatosFacturacion: this.datosFacturacion.emisorDatosId,
				idPlanUsuario: this.planActual?.idPlanUsuario,
			})
			.subscribe({
				next: (result: any) => {
					if (result.status === 200 && result.data?.pago === "webpay") {
						this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((paymentCompleted) => {
							this.pagandoDeudaAdicional = false;
							this.ref.detectChanges();
							if (paymentCompleted) {
								Swal.fire({
									icon: "success",
									title: "Deuda regularizada",
									text: "El pago de tus facturas pendientes por adicionales fue registrado correctamente.",
								}).then(() => this.loadPendingAdditionalDebt(this.planActual?.emisorId ?? this.emisorId));
							} else {
								Swal.fire({
									icon: "warning",
									title: "Pago en proceso",
									text: "No obtuvimos confirmación del pago. Si fue procesado, la deuda dejará de mostrarse en breves minutos.",
								}).then(() => this.loadPendingAdditionalDebt(this.planActual?.emisorId ?? this.emisorId));
							}
						});
					} else {
						this.finalizarPagoDeudaConError("No fue posible iniciar el pago. Intenta nuevamente.");
					}
				},
				error: (error: any) => {
					this.finalizarPagoDeudaConError("No se pudo registrar la transacción. " + this.utilities.setErrorMessageFromArray(error.error));
				},
			});
	}

	private finalizarPagoDeudaConError(mensaje: string): void {
		this.pagandoDeudaAdicional = false;
		this.ref.detectChanges();
		Swal.fire({ icon: "error", title: "Error al procesar el pago", text: mensaje });
	}

	payPlan(modalRef) {
		this.loading = true;
		this.planService.getInitialData().subscribe((data) => {
			this.planes = data.planes || [];
			this.certificaciones = data.certificaciones || [];
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				this.loading = false;
				this.ref.detectChanges();
				if (response.data.planesUsuario.length == 0) {
					Swal.fire({ title: "¡Ups! Un problema", text: "Solo el administrador de la empresa puede pagar el plan.", icon: "warning" });
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.planActual.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.handleUserData(response.data, "payment");
				this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "xl" });
				setTimeout(() => { this.pagoService.triggerCalculations(); }, 0);
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	changePlan(modalRef) {
		this.loading = true;
		if (!this.planActual) {
			this.loading = false;
			this.ref.detectChanges();
			Swal.fire({ title: "Error", text: "No se encontró el plan actual. Intenta recargar la página.", icon: "warning" });
			return;
		}
		this.planService.getInitialData().subscribe((data) => {
			const fechaCorte = this.toDayMoment(this.planActual.fechaCorte);
			const fechaActual = this.todayDayMoment();
			const planesNuevos = data.planes.filter(
				(plan) => plan.id === this.planActual.idPlanSf && plan.antiguedad === "Nuevo"
			);
			if (fechaActual.isSameOrAfter(fechaCorte, "day") || planesNuevos.length > 0) {
				this.planes = data.planes.filter((plan) => plan.antiguedad === "Nuevo");
			} else {
				const planesFiltrados = data.planes.filter(
					(plan) => plan.antiguedad === "Nuevo" && plan.nombre !== this.planActual.nombrePlan
				);
				const indiceOriginal = data.planes.findIndex((plan) => plan.id === this.planActual.idPlanSf);
				let posicionInsercion = 0;
				for (const plan of planesFiltrados) {
					const indicePlan = data.planes.findIndex((p) => p.nombre === plan.nombre);
					if (indicePlan < indiceOriginal) posicionInsercion++;
				}
				this.planes = [...planesFiltrados];
				const planCorrespondiente = data.planes.find((p) => p.id === this.planActual.idPlanSf);
				if (planCorrespondiente) {
					planCorrespondiente.id = this.planActual.idPlanSf;
					this.planes.splice(posicionInsercion, 0, planCorrespondiente);
				}
			}
			this.certificaciones = data.certificaciones || [];
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				this.setPlanesNoSeleccionables(response?.data?.planesUsuario || []);
				if (response.data.planesUsuario.length == 0) {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({ title: "¡Ups! Un problema", text: "Solo el administrador de la empresa puede cambiar el plan.", icon: "warning" });
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.planActual.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.downgradeRestringido = !this.puedeHacerDowngrade;
				this.fechaHabilitacionDowngrade = this.fechaHabilitacionDowngradeCalc;
				this.handleUserData(response.data, "change");
				this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "xl" });
				if (this.planSeleccionado == null) {
					this.planSeleccionado = this.planes.find((x) => x.id === this.planActual.idPlanSf);
				}
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	extendPlan(modalRef) {
		this.loading = true;
		if (!this.planActual) {
			this.loading = false;
			this.ref.detectChanges();
			Swal.fire({ title: "Error", text: "No se encontró el plan actual. Intenta recargar la página.", icon: "warning" });
			return;
		}
		this.planService.getInitialData().subscribe((data) => {
			this.planes = data.planes || [];
			this.certificaciones = data.certificaciones || [];
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				this.loading = false;
				this.ref.detectChanges();
				if (response.data.planesUsuario.length == 0) {
					Swal.fire({ title: "¡Ups! Un problema", text: "Solo el administrador de la empresa puede extender el plan.", icon: "warning" });
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.handleUserData(response.data, "extend");
				this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "xl" });
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	buyCertifications(modalRef) {
		if (this.isCertModalOpen) return;
		this.isCertModalOpen = true;
		this.loading = true;
		this.planService.getCertificacionesCompra(this.emisorId).subscribe({
			next: (resp) => {
				let certs: CertificacionPrecio[] = [];
				if (Array.isArray(resp)) {
					certs = resp;
				} else if (resp && (resp as any).certificaciones) {
					certs = (resp as any).certificaciones;
				} else if (resp && (resp as any).data) {
					certs = (resp as any).data;
				}
				this.inicializarSeleccionCertificaciones(certs);
				this.userService.getUser(this.user.id, this.emisorId).subscribe({
					next: (response) => {
						if (response.data.planesUsuario.length == 0) {
							Swal.fire({ title: "¡Ups! Un problema", text: "Solo el administrador de la empresa puede comprar certificaciones.", icon: "warning" });
							return;
						}
						this.handleUserData(response.data, "certifications");
						this.datosFacturacionServicce.getData(this.usuarioId, this.emisorId).subscribe({
							next: (data) => {
								this.rowsDatosFacturacion = data;
								this.datosFacturacion = data.find((x) => x.emisorId == this.emisorId);
								this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "xl" });
								this.paymentPlanModal.result.then(
									() => { this.isCertModalOpen = false; this.certModalLoading = false; },
									() => { this.isCertModalOpen = false; this.certModalLoading = false; }
								);
								this.certModalLoading = true;
								setTimeout(() => this.recalcularResumenCertificaciones(), 0);
								this.loading = false;
								this.ref.detectChanges();
							},
							error: (err) => {
								this.loading = false;
								this.isCertModalOpen = false;
								this.ref.detectChanges();
								this.handleError(err);
							},
						});
					},
					error: (err) => {
						this.loading = false;
						this.ref.detectChanges();
						this.handleError(err);
					},
				});
			},
			error: (err) => {
				this.loading = false;
				this.isCertModalOpen = false;
				this.ref.detectChanges();
				this.handleError(err);
			},
		});
	}

	recalcularResumenCertificaciones(): void {
		this.certModalLoading = true;
		this.ref.detectChanges();
		if (!this.datosFacturacion || !this.certificaciones) {
			this.certModalLoading = false;
			this.ref.detectChanges();
			return;
		}
		const payload = {
			idEmisor: this.datosFacturacion.emisorId || this.emisorId,
			idDatosFacturacion: this.datosFacturacion.emisorDatosId || null,
			idPlanUsuario: this.planActual ? this.planActual.idPlanUsuario : null,
			certificaciones: this.certificaciones || [],
		};
		this.isCalculatingCerts = true;
		this.planService.getCalculosCertificacionesCompra(payload).subscribe({
			next: (resumen) => {
				this.resumenCuenta = resumen;
				this.isCalculatingCerts = false;
				this.certModalLoading = false;
				this.ref.detectChanges();
			},
			error: (err) => {
				this.isCalculatingCerts = false;
				this.certModalLoading = false;
				this.ref.detectChanges();
				this.handleError(err);
			},
		});
	}

	private inicializarSeleccionCertificaciones(certs: CertificacionPrecio[]): void {
		this.certificaciones = certs;
		// `disabled` expresa inelegibilidad; nunca debe convertirse en una selección
		// enviada al backend. Las selecciones previas se cargan después desde el plan.
		this.certificaciones.forEach((certificacion) => (certificacion.solicitada = false));
	}

	handleUserData(userData: any, type: string): void {
		let planActual: PlanUsuario;
		if (this.planActual?.idPlanUsuario != null) {
			planActual = userData.planesUsuario.find((y) => y.idPlanUsuario === this.planActual.idPlanUsuario);
			if (type !== "certifications") {
				if (this.certificaciones?.length) this.certificaciones.forEach((x) => (x.solicitada = false));
				if (userData.certificacionesPendientes?.length && this.certificaciones?.length) {
					userData.certificacionesPendientes.forEach((x) => {
						const certTemp = this.certificaciones.find((z) => z.codigoPrincipal === x.codigoPrincipal);
						if (certTemp) certTemp.solicitada = true;
					});
				}
			}
			this.handlePlanActual(userData, planActual);
		} else {
			planActual = userData.planesUsuario[0];
			this.handlePlanActual(userData, planActual);
		}
		if (!this.user.configured && planActual?.pagado && !planActual?.activo) {
			let resumenCuenta = new Resumen();
			resumenCuenta.pagado = planActual.pagado;
			resumenCuenta.idPlanUsuario = planActual.idPlanUsuario;
			resumenCuenta.idPlanSf = planActual.idPlanSf;
			resumenCuenta.formaPago = planActual.formaPago;
			resumenCuenta.nombrePlan = planActual.nombrePlan;
			resumenCuenta.change = type == "change";
			resumenCuenta.extend = type == "extend";
			this.notifyResumen(resumenCuenta);
		}
	}

	handlePlanActual(userData: any, planActual: PlanUsuario): void {
		const fechaCorte = this.planActual?.fechaCorte ? this.toDayMoment(this.planActual.fechaCorte) : null;
		const fechaCaducidad = this.planActual?.fechaCaducidad ? this.toDayMoment(this.planActual.fechaCaducidad) : null;
		if (!fechaCorte || !fechaCaducidad || fechaCorte.isBefore(fechaCaducidad, "day")) {
			this.planSeleccionado = this.planes.find((x) => x.nombre === this.planActual.nombrePlan && x.antiguedad == "Nuevo");
		} else {
			this.planSeleccionado = this.planes.find((x) => x.nombre === planActual.nombrePlan && x.antiguedad == "Antiguo");
		}
		if (planActual?.activo == false) {
			if (this.certificaciones?.length) {
				this.certificaciones.forEach((x) => {
					x.idPlanUsuario = planActual.idPlanUsuario;
					x.solicitada = (userData.certificacionesPendientes || []).some((y) => y.codigoPrincipal === x.codigoPrincipal);
				});
			}
			this.ref.detectChanges();
		} else {
			setTimeout(() => { this.pagoService.triggerCalculations(); }, 0);
		}
		if (this.certificaciones?.length) {
			this.certificaciones.forEach((x) => (x.idPlanUsuario = planActual.idPlanUsuario));
		}
	}

	handleError = (error): void => {
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	};

	notifyResumen(resumen: Resumen): void {
		this.nuevaFechaCaducidad = this.toDayMoment(resumen.fechaTermino);
		this.resumenCuenta = resumen;
		this.hasAdicionales = resumen.adicionales.filter((x) => x.checked).length > 0;
		if (this.planActual) {
			resumen.adicionales.forEach((x) => (x.fechaInicio = this.planActual.fechaCaducidad));
		}
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;
		setTimeout(() => { this.pagoService.triggerCalculations(); }, 0);
	}

	public isPlanNoSeleccionable(plan: Plan): boolean {
		if (!plan) return true;
		const planId = this.normalizarValorPlan(plan.id);
		return planId ? this.planesNoSeleccionablesIds.some((x) => this.normalizarValorPlan(x) === planId) : false;
	}

	mostrarVentanaWebPay(): boolean {
		const attribute = document.body.getAttribute("data-mostrar-webpay");
		return !attribute || attribute !== "false";
	}

	pagar(type: string) {
		if (type === "certifications") {
			this.abrirModalFechaCertificacion(type);
			return;
		}
		if (this.certificaciones?.some((c) => c.solicitada)) {
			this.abrirModalFechaCertificacion(type);
		} else {
			this.ejecutarPago(type);
		}
	}

	private abrirModalFechaCertificacion(type: string): void {
		this.fechaCertificacion = this.fechaActual.format("YYYY-MM-DD");
		this.paymentType = type;
		this.certificacionFechaModal = this.modalService.open(this.certificacionFechaForm, {
			size: "md",
			backdrop: "static",
			keyboard: false,
		});
		this.certificacionFechaModal.result.then((result) => {
			if (result === "confirm") {
				this.resumenCuenta.fechaConfirmada = moment(this.fechaCertificacion).toDate();
				this.ejecutarPago(this.paymentType);
			}
		});
	}

	private ejecutarPago(type: string) {
		if (
			type === "change" &&
			!this.resumenCuenta?.idPlanUsuarioAntiguo &&
			this.planSeleccionado &&
			this.planActual &&
			this.planSeleccionado.precio > this.planActual.pagoMensual &&
			this.todayDayMoment().isBefore(this.toDayMoment(this.planActual.fechaCaducidad), "day")
		) {
			this.resumenCuenta.idPlanUsuarioAntiguo = this.planActual.idPlanUsuario;
		}

		if (
			type === "change" &&
			!this.resumenCuenta?.idPlanUsuarioAntiguo &&
			this.planSeleccionado &&
			this.planActual &&
			this.isDowngrade(this.planSeleccionado)
		) {
			this.resumenCuenta.idPlanUsuarioAntiguo = this.planActual.idPlanUsuario;
		}
		const planBase = this.planes.find((x) => x.id === this.planActual.idPlanSf);
		if (this.planActual.maxUsuarios > planBase.usuarios) {
			Swal.fire({
				icon: "error",
				title: "Error en el cambio de plan",
				text: "Se detectó que cuentas con un plan que supera el número de usuarios del plan seleccionado. Por favor, contacta a soporte.",
			}).then((result) => {
				this.loading = false;
				this.ref.detectChanges();
				if (result.value) this.paymentPlanModal.close();
			});
			return;
		}
		this.resumenCuenta.idDatosFacturacion = this.datosFacturacion.emisorDatosId;
		this.resumenCuenta.idEmisor = this.datosFacturacion.emisorId;
		this.resumenCuenta.idUsuario = this.usuarioId;
		this.resumenCuenta.idPlanSf = type == "change" ? this.planSeleccionado.id : this.planActual.idPlanSf;
		this.resumenCuenta.certificaciones = this.certificaciones;
		this.resumenCuenta.payment = true;
		this.loading = true;
		const paymentService =
			type === "certifications"
				? this.planService.purchaseCertificationsPayment(this.resumenCuenta)
				: this.planService.doPayment(this.resumenCuenta);

		paymentService.subscribe(
			(result) => {
				if (result.status == 200) {
					if (result.data.pago == "webpay") {
						if (this.mostrarVentanaWebPay()) {
							this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((paymentCompleted) => {
								this.loading = false;
								this.ref.detectChanges();
								if (paymentCompleted) {
									Swal.fire({ icon: "success", title: "Pago realizado", text: "Se ha extendido exitosamente tu plan." }).then((r) => {
										if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
									});
								} else {
									Swal.fire({ icon: "warning", title: "Pago en verificación", text: "No obtuvimos respuesta del pago. Si se efectuó será procesado en breves minutos." }).then((r) => {
										if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
									});
								}
							});
						} else {
							this.cypressService.processManualPayment(true, this.resumenCuenta.total).subscribe((data) => {
								this.loading = false;
								this.ref.detectChanges();
								if (data.status == 200) {
									Swal.fire({
										icon: "success",
										title: "Pago realizado",
										text: "El pago se ha realizado correctamente. " + this.datosFacturacion.razonSocial + ". Debes iniciar sesión de nuevo para operar con tu empresa.",
									}).then((r) => { if (r.value) { this.paymentPlanModal.close(); this.authService.logout().subscribe(); } });
								}
							});
						}
					} else if (SaldoPagoUi.esCoberturaTotal(result.data)) {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Compra completada con saldo",
							text: "La operación fue completada utilizando tu saldo a favor.",
						}).then((dialog) => {
							if (dialog.value) { this.paymentPlanModal.close(); this.loadData(); }
						});
					} else {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({ icon: "success", title: "Pago realizado", text: "Operación terminada. Si el pago fue realizado con éxito se verá reflejado en breves segundos" }).then((r) => {
							if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
						});
					}
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				if (this.manejarDeudaPendiente(error)) return;
				if (SaldoPagoUi.esConflicto(error)) {
					SaldoPagoUi.limpiarSeleccion(this.resumenCuenta);
					solicitarRefrescoSaldo();
					Swal.fire({
						icon: "warning",
						title: "Tu saldo disponible cambió",
						text: "El saldo disponible cambió. Revisa el total actualizado y confirma nuevamente la compra.",
					});
					return;
				}
				Swal.fire({
					icon: "error",
					title: "Error al realizar el pago",
					text: "No se ha podido registrar el pago" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	private manejarDeudaPendiente(error: any): boolean {
		if (error?.status !== 409 || error?.error?.code !== "DEUDA_PENDIENTE") {
			return false;
		}
		Swal.fire({
			icon: "warning",
			title: "Tienes deuda pendiente",
			text: error?.error?.message ?? "Debes regularizar tu deuda pendiente antes de contratar.",
			confirmButtonText: "Ir a regularizar",
		}).then(() => {
			this.paymentPlanModal?.close();
			this.router.navigate(["/pago/regularizacion"]);
		});
		return true;
	}
	actualizarPago(resumen) {
		this.resumenCuenta = resumen;
	}

	private setPlanesNoSeleccionables(planesUsuario: PlanUsuario[]): void {
		const ids = new Set<string>();
		(planesUsuario ?? []).filter((p) => p?.activo === true).forEach((plan) => {
			const id = this.normalizarValorPlan(plan?.idPlanSf);
			if (id) ids.add(id);
		});
		const idPlanActual = this.normalizarValorPlan(this.planActual?.idPlanSf);
		if (idPlanActual) ids.add(idPlanActual);
		this.planesNoSeleccionablesIds = Array.from(ids);
	}

	private normalizarValorPlan(value: any): string {
		return value == null ? "" : String(value).trim().toLowerCase();
	}

	actualizarCertificaciones(certificaciones) {
		if (this.certModalLoading || this.isCalculatingCerts) return;
		const now = Date.now();
		if (now - this.lastCertChangeTime < 1000) return;
		this.lastCertChangeTime = now;
		this.certificaciones = certificaciones;
		if (this.isCertModalOpen) {
			this.certModalLoading = true;
			this.ref.detectChanges();
			this.certsChange$.next();
		}
	}

	onCertCheckboxClick(event: MouseEvent) {
		if (this.certModalLoading || this.isCalculatingCerts) {
			event.preventDefault();
			event.stopPropagation();
			(event.target as HTMLInputElement).checked = !(event.target as HTMLInputElement).checked;
			return false;
		}
		return true;
	}

	private loadAdicionalesDisponibles(onComplete: () => void): void {
		const yaVigenteIds = new Set(this.adicionalesVigentes.map((a) => a.idAdicional));
		const esPlanIndependiente = this.planActual?.nombrePlan?.toLowerCase().includes("independiente") ?? false;

		this.planService.getAdicionalesCatalogo(this.user.isPartner).subscribe({
			next: (catalogo) => {
				this.adicionalesDisponibles = catalogo
					.filter((item) => !yaVigenteIds.has(item.idAdicional))
					.map((item) => {
						const esRecibidos = item.idAdicional === AdicionalType.Recibidos;
						const readOnly = esRecibidos && !esPlanIndependiente;
						const a = new Adicional(item.precio, false, readOnly, item.idAdicional);
						a.nombre = item.nombre;
						a.descripcion = readOnly ? item.descripcion + " (Incluido en tu plan actual)" : item.descripcion;
						a.message = readOnly
							? "Incluído con tu plan"
							: item.precio > 0
							? `Valor: $${item.precio.toLocaleString("es-CL")}`
							: "Gratis";
						return a;
					});
				this.ref.detectChanges();
				onComplete();
			},
			error: () => {
				this.adicionalesDisponibles = [];
				this.ref.detectChanges();
				onComplete();
			},
		});
	}

	contratarAdicional(modalRef: TemplateRef<any>) {
		if (this.isAdicionalesModalOpen) return;
		this.isAdicionalesModalOpen = true;
		this.saldoAdicionales = { usarSaldoFavor: false, saldoAplicadoEsperado: 0 };
		this.loading = true;
		this.userService.getUser(this.user.id, this.emisorId).subscribe({
			next: (response) => {
				if (!response.data.planesUsuario.length) {
					this.loading = false;
					this.isAdicionalesModalOpen = false;
					this.ref.detectChanges();
					Swal.fire({ title: "¡Ups!", text: "Solo el administrador puede contratar adicionales.", icon: "warning" });
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.emisorId).subscribe({
					next: (data) => {
						this.cotizacionAdicionales = null;
						this.rowsDatosFacturacion = data;
						this.datosFacturacion = data.find((x) => x.emisorId === this.planActual.emisorId) ?? data[0];
						this.loadAdicionalesDisponibles(() => {
							this.loading = false;
							this.ref.detectChanges();
							this.paymentPlanModal = this.modalService.open(modalRef, { size: "xl", windowClass: "pf-modal-adicionales" });
							this.paymentPlanModal.result.then(
								() => { this.isAdicionalesModalOpen = false; },
								() => { this.isAdicionalesModalOpen = false; }
							);
						});
					},
					error: (err) => {
						this.loading = false;
						this.isAdicionalesModalOpen = false;
						this.ref.detectChanges();
						this.handleError(err);
					},
				});
			},
			error: (err) => {
				this.loading = false;
				this.isAdicionalesModalOpen = false;
				this.ref.detectChanges();
				this.handleError(err);
			},
		});
	}

	cotizarAdicionales(): void {
		const adicionales = this.adicionalesChecked.filter((a) => !this.isPaykuAdicional(a));
		if (!adicionales.length) {
			this.cotizacionAdicionales = null;
			this.ref.detectChanges();
			return;
		}
		this.planService.quoteAdicionales({
			idEmisor: this.datosFacturacion?.emisorId,
			idPlanUsuario: this.planActual?.idPlanUsuario,
			idDatosFacturacion: this.datosFacturacion?.emisorDatosId,
			adicionales: adicionales.map((a) => a.idAdicional)
		}).subscribe({
			next: (cotizacion) => { this.cotizacionAdicionales = cotizacion; this.ref.detectChanges(); },
			error: () => { this.cotizacionAdicionales = null; this.ref.detectChanges(); }
		});
	}

	ejecutarPagoAdicionales() {
		const adicionalesSeleccionados = this.adicionalesChecked;
		if (!adicionalesSeleccionados.length) return;

		const adicionalesPayku = adicionalesSeleccionados.filter((a) => this.isPaykuAdicional(a));
		const adicionalesPago = adicionalesSeleccionados.filter((a) => !this.isPaykuAdicional(a));

		this.loading = true;
		this.ref.detectChanges();

		const continuarConPago = () => {
			if (!adicionalesPago.length) {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({ icon: "success", title: "Adicional confirmado", text: "Payku fue activado correctamente." }).then((r) => {
					if (r.value) {
						this.paymentPlanModal.close();
						this.loadData();
					}
				});
				return;
			}
			this.procesarPagoAdicionales(adicionalesPago);
		};

		if (adicionalesPayku.length) {
			this.planService
				.confirmPaykuDirecto(this.buildPaykuDirectoPayload(adicionalesPayku[0]))
				.subscribe({
					next: () => continuarConPago(),
					error: (error: any) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error al confirmar Payku",
							text: "No se pudo activar el adicional Payku" + this.utilities.setErrorMessageFromArray(error.error),
						});
					},
				});
			return;
		}

		this.procesarPagoAdicionales(adicionalesPago);
	}

	private buildPaykuDirectoPayload(payku: Adicional) {
		return {
			idEmisor: this.datosFacturacion.emisorId,
			idUsuario: this.usuarioId,
			nombre: payku?.nombre ?? "Payku",
			descripcion: payku?.descripcion ?? "",
			fechaInicio: new Date(),
		};
	}

	private buildAdicionalesPaymentPayload(adicionales: Adicional[]) {
		const neto = this.cotizacionAdicionales?.neto ?? 0;
		const iva = this.cotizacionAdicionales?.iva ?? 0;
		const total = this.cotizacionAdicionales?.total ?? 0;

		return {
			idEmisor: this.datosFacturacion.emisorId,
			idUsuario: this.usuarioId,
			idPlanUsuario: this.planActual.idPlanUsuario,
			idDatosFacturacion: this.datosFacturacion.emisorDatosId,
			nombrePlan: this.planActual?.nombrePlan ?? "",
			FormaPago: this.planActual?.formaPago || "webpay",
			Certificaciones: [],
			Adicionales: adicionales.map((a) => ({
				idAdicional: a.idAdicional,
				nombre: a.nombre,
				precio: 0,
				checked: true,
				idEmisor: this.datosFacturacion.emisorId,
				descripcion: a.descripcion ?? "",
				activo: true,
				readOnly: false,
				message: a.message ?? "",
				fechaTermino: null,
			})),
			neto,
			iva,
			total,
			subtotal: neto,
			meses: 0,
			usarSaldoFavor: this.saldoAdicionales.usarSaldoFavor,
			saldoAplicadoEsperado: this.saldoAdicionales.usarSaldoFavor
				? this.saldoAdicionales.saldoAplicadoEsperado
				: 0,
		};
	}

	getMontoLineaAdicional(adicional: Adicional): number {
		return this.getMontoAdicionalCalculado(adicional);
	}

	private getMontoAdicionalCalculado(adicional: Adicional): number {
		return this.cotizacionAdicionales?.lineas?.find((x) => x.idAdicional === adicional.idAdicional)?.precioProrrateado ?? 0;
	}

	private procesarPagoAdicionales(adicionales: Adicional[]) {
		const payload = this.buildAdicionalesPaymentPayload(adicionales);
		this.planService.purchaseAdicionalesPayment(payload).subscribe({
			next: (result: any) => {
				if (result.status === 200) {
					if (result.data.pago === "webpay") {
						if (this.mostrarVentanaWebPay()) {
							this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((paymentCompleted) => {
								this.loading = false;
								this.ref.detectChanges();
								if (paymentCompleted) {
									Swal.fire({ icon: "success", title: "Pago realizado", text: "Los adicionales seleccionados han sido activados." }).then((r) => {
										if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
									});
								} else {
									Swal.fire({ icon: "warning", title: "Pago en proceso", text: "No obtuvimos confirmación del pago. Si fue procesado, los adicionales se activarán en breves minutos." }).then((r) => {
										if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
									});
								}
							});
						}
					} else if (SaldoPagoUi.esCoberturaTotal(result.data)) {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({ icon: "success", title: "Compra completada con saldo", text: "Los adicionales fueron activados utilizando tu saldo a favor." }).then((dialog) => {
							if (dialog.value) { this.paymentPlanModal.close(); this.loadData(); }
						});
					} else {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({ icon: "success", title: "Adicional activado", text: "El adicional ha sido activado correctamente." }).then((r) => {
							if (r.value) { this.paymentPlanModal.close(); this.loadData(); }
						});
					}
				}
			},
			error: (error: any) => {
				this.loading = false;
				this.ref.detectChanges();
				if (this.manejarDeudaPendiente(error)) return;
				if (SaldoPagoUi.esConflicto(error)) {
					this.saldoAdicionales = { usarSaldoFavor: false, saldoAplicadoEsperado: 0 };
					solicitarRefrescoSaldo();
					Swal.fire({
						icon: "warning",
						title: "Tu saldo disponible cambió",
						text: "El saldo disponible cambió. Revisa el total actualizado y confirma nuevamente la compra.",
					});
					return;
				}
				Swal.fire({
					icon: "error",
					title: "Error al procesar el pago",
					text: "No se pudo registrar la transacción" + this.utilities.setErrorMessageFromArray(error.error),
				});
			},
		});
	}

	openFacturas(modalRef) {
		this.planService.getFacturasByPlan(this.planActual.idPlanUsuario).subscribe((data) => {
			this.facturasPlan = data;
		});
		this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "lg", centered: true });
	}

	openAdicionales(modalRef) {
		this.emisorService.getAdicionales(this.planActual.emisorId).subscribe((data) => {
			this.adicionales = data;
		});
		this.paymentPlanModal = this.modalService.open(modalRef, { windowClass: "", size: "xl", centered: true });
	}

	openUsuarios() {
		this.router.navigateByUrl("/mantenedores/usuarios");
	}

	openPDF(idFactura) {
		this.loading = true;
		this.ref.detectChanges();
		this.planService.getFacturaPDF(idFactura).subscribe({
			next: (data) => {
				this.loading = false;
				this.ref.detectChanges();
				const pdfBlob = this.utilities.convertB64ToBlob(data.data, "application/pdf");
				const pdfUrl = URL.createObjectURL(pdfBlob);
				this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
			},
			error: () => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "No se pudo obtener el documento",
					text: "No fue posible generar el PDF de la factura. Intenta nuevamente o contacta a soporte.",
				});
			},
		});
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
		const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
		const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(url, title, `scrollbars=yes,width=${w / systemZoom},height=${h / systemZoom},top=${top},left=${left}`);
		if (window.focus) newWindow.focus();
	}
}
